<div class="flex min-h-screen items-center justify-center px-4 py-8">
  <div class="flex w-full max-w-md flex-col gap-6">
    <app-logo [widthInPx]="120" />

    <div hlmCard>
      <div hlmCardHeader>
        <h1 hlmCardTitle>Neue E-Mail bestätigen</h1>
        <p hlmCardDescription>Wir prüfen deinen Bestätigungslink.</p>
      </div>

      <div hlmCardContent class="space-y-4">
        @if (loading) {
          <div class="flex flex-col items-center gap-3 py-6 text-center">
            <hlm-spinner class="text-[length:--spacing(8)]" />
            <p hlmMuted class="text-sm">Wird bestätigt…</p>
          </div>
        } @else if (verified) {
          <div hlmAlert>
            <ng-icon name="lucideCircleCheck" />
            <p hlmAlertTitle>E-Mail-Adresse erfolgreich geändert</p>
            <p hlmAlertDescription>
              Deine neue E-Mail-Adresse ist aktiv – du kannst dich ab sofort damit anmelden.
            </p>
          </div>

          <button hlmBtn class="w-full" (click)="goToSettings()">Zu den Einstellungen</button>
        } @else {
          <div hlmAlert variant="destructive">
            <ng-icon name="lucideTriangleAlert" />
            <p hlmAlertTitle>Bestätigung fehlgeschlagen</p>
            <p hlmAlertDescription>{{ error }}</p>
          </div>

          <button hlmBtn variant="outline" class="w-full" (click)="goToSettings()">
            Zu den Einstellungen
          </button>
        }
      </div>
    </div>
  </div>
</div>
